import api from "../api";

export interface ImpactStat {
  animationType: "counter" | "percentage" | "static";
  color: string;
  description: string;
  icon: string;
  id: string;
  isActive: boolean;
  order: number;
  title: string;
  value: string;
}

function mapImpactStat(s: any): ImpactStat {
  return {
    animationType: s.animation_type,
    color: s.color_theme ?? s.color,
    description: s.description ?? "",
    icon: s.icon,
    id: String(s.id),
    isActive: !s.hidden,
    order: s.order ?? 0,
    title: s.title,
    value: s.value,
  };
}

export const ImpactStatService = {
  create: async (data: ImpactStat): Promise<ImpactStat> => {
    const payload = {
      animation_type: data.animationType,
      color_theme: data.color, // <-- FIXED: use color_theme
      description: data.description,
      hidden: data.isActive ? 0 : 1,
      icon: data.icon,
      order: data.order,
      title: data.title,
      value: data.value,
    };
    console.log("ImpactStat create payload:", payload);
    const response = await api.post("/impact-stats", payload);
    return mapImpactStat(response.data.stat);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/impact-stats/${id}`);
  },

  getAll: async (): Promise<ImpactStat[]> => {
    const response = await api.get("/impact-stats");
    return (response.data.stats || []).map(mapImpactStat);
  },

  hide: async (id: string): Promise<ImpactStat> => {
    const response = await api.post(`/impact-stats/${id}/hide`);
    return mapImpactStat(response.data.stat);
  },

  unhide: async (id: string): Promise<ImpactStat> => {
    const response = await api.post(`/impact-stats/${id}/unhide`);
    return mapImpactStat(response.data.stat);
  },

  update: async (id: string, data: ImpactStat): Promise<ImpactStat> => {
    const payload = {
      animation_type: data.animationType,
      color_theme: data.color, // <-- FIXED: use color_theme
      description: data.description,
      hidden: data.isActive ? 0 : 1,
      icon: data.icon,
      order: data.order,
      title: data.title,
      value: data.value,
    };
    console.log("ImpactStat update payload:", payload);
    const response = await api.post(`/impact-stats/${id}`, payload);
    return mapImpactStat(response.data.stat);
  },
};
